export const ClearEmptyJson = (json) => {
    const filteredData = Object.keys(json).filter(key => {
        const value = json[key];
        return value !== null && value !== 0 && value !== "";
    }).reduce((obj, key) => {
        obj[key] = json[key];
        return obj;
    }, {});
    return filteredData;
}